/** biome-ignore-all lint/suspicious/noExplicitAny: TODO: fix */
import { DEFAULT_STORE_OBJECT } from '@/redux/constants';
import type { DefaultStoreObject } from '@/redux/types';
import type {
  ProcurementLane,
  ProcurementTender,
  ProcurementTenderHistoricalBid,
  ProcurementTenderTransportProvider,
} from '@/views/screens/Procurement';

import ProcurementTenderType from './ProcurementTenderType';
import getTenderCopy from './requestPayload/GetTenderCopy';
import getTenderListBySearchReq from './requestPayload/GetTenderListBySearch';

export interface ProcurementTenderState extends Record<string, any> {
  addNewBidParameterActions: {
    btnCliked: boolean;
  };
  addNewLaneBtnClicked: boolean;
  activeTender?: {
    data: ProcurementTender;
  };
  tenderList: DefaultStoreObject<ProcurementTender[]> & {
    req: Record<string, any>;
    totalModeTest?: number;
    totalModeProd?: number;
    totalCount?: number;
  };
  LaneInformationList: DefaultStoreObject<ProcurementLane[]>;
  transportProviderList: DefaultStoreObject<ProcurementTenderTransportProvider[]> & {
    req?: Record<string, any>;
  };
  historicalBidList: DefaultStoreObject<ProcurementTenderHistoricalBid> & {
    req?: Record<string, any>;
  };
}

const initialState: ProcurementTenderState = {
  addNewBidParameterActions: {
    btnCliked: false,
  },
  addNewLaneBtnClicked: false,
  historicalBidList: {
    ...DEFAULT_STORE_OBJECT,
    data: {} as ProcurementTenderHistoricalBid,
  },
  LaneInformationList: {
    ...DEFAULT_STORE_OBJECT,
    data: [],
  },
  tenderList: {
    ...DEFAULT_STORE_OBJECT,
    data: [],
    req: {
      ...getTenderListBySearchReq,
    },
  },
  transportProviderList: {
    ...DEFAULT_STORE_OBJECT,
    data: [],
  },
};

const ProcurementTenderReducer = (state = initialState, { type, payload }: any): ProcurementTenderState => {
  switch (type) {
    case ProcurementTenderType.ADD_NEW_LANE_BUTTON: {
      return {
        ...state,
        addNewLaneBtnClicked: payload,
      };
    }
    case ProcurementTenderType.GET_PROCUREMENT_TENDER_LIST: {
      return {
        ...state,
        tenderList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.tenderList,
          progressing: true,
          req: {
            ...state.tenderList.req,
            ...payload,
          },
        },
      };
    }
    case ProcurementTenderType.GET_PROCUREMENT_TENDER_LIST_SUCCESS: {
      return {
        ...state,
        tenderList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.tenderList,
          data: [...(state?.tenderList?.data || []), ...(payload?.data?.tenderViewModel || [])],
          progressing: false,
          success: true,
          totalCount: payload?.data?.totalCount,
          totalModeProd: payload?.data?.totalModeProd,
          totalModeTest: payload?.data?.totalModeTest,
        },
      };
    }

    case ProcurementTenderType.GET_PROCUREMENT_TENDER_LIST_FAIL: {
      return {
        ...state,
        tenderList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.tenderList,
          data: payload.data,
          error: true,
          progressing: false,
          totalCount: 0,
          totalModeProd: 0,
          totalModeTest: 0,
        },
      };
    }

    case ProcurementTenderType.UPDATE_PROCUREMENT_TENDER_INFO_REQUEST:
      return {
        ...state,
        req: {
          ...state.getTenderListBySearchReq,
          ...payload,
        },
      };

    case ProcurementTenderType.GET_PROCUREMENT_TENDER_LIST_REQUEST_RESET:
      return {
        ...state,
        tenderList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.tenderList,
          data: [],
          req: {
            ...state.tenderList.req,
            ...payload,
          },
        },
      };

    /** Active Tender Item set and reset reducer start */

    case ProcurementTenderType.SET_ACTIVE_TENDER_ITEM:
      return {
        ...state,
        activeTender: {
          data: payload,
        },
      };

    case ProcurementTenderType.RESET_ACTIVE_TENDER_ITEM:
      return {
        ...state,
        activeTender: {
          data: {} as ProcurementTender,
        },
      };
    /** Active Tender Item set and reset reducer end */

    /**Tender Copy reducer start */
    case ProcurementTenderType.CREATE_TENDER_COPY:
      return {
        ...state,
        tenderCopy: {
          ...DEFAULT_STORE_OBJECT,
          progressing: true,
          req: {
            ...state.tenderCopy.req,
            ...payload,
          },
        },
      };

    case ProcurementTenderType.CREATE_TENDER_COPY_SUCCESS:
      return {
        ...state,
        tenderCopy: {
          ...DEFAULT_STORE_OBJECT,
          ...state.tenderCopy,
          data: payload.data,
          error: false,
          progressing: false,
          success: true,
        },
      };

    case ProcurementTenderType.CREATE_TENDER_COPY_FAIL:
      return {
        ...state,
        tenderCopy: {
          ...DEFAULT_STORE_OBJECT,
          ...state.tenderCopy,
          data: payload,
          error: true,
          progressing: false,
          success: false,
        },
      };

    case ProcurementTenderType.CREATE_TENDER_COPY_RESET:
      return {
        ...state,
        tenderCopy: {
          ...DEFAULT_STORE_OBJECT,
          ...state.tenderCopy,
          data: [],
          error: false,
          req: {
            ...getTenderCopy,
          },
          success: false,
        },
      };
    /** Tender Copy reducer  end */

    case ProcurementTenderType.ADD_NEW_BID_PARAMETER_ACTION:
      return {
        ...state,
        addNewBidParameterActions: {
          btnCliked: payload,
        },
      };

    case ProcurementTenderType.GET_PROCUREMENT_LANE_INFORMATION:
      return {
        ...state,
        LaneInformationList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.LaneInformationList,
          progressing: true,
        },
      };

    case ProcurementTenderType.GET_PROCUREMENT_LANE_INFORMATION_SUCCESS:
      return {
        ...state,
        LaneInformationList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.LaneInformationList,
          data: payload.data,
          progressing: false,
          success: true,
        },
      };

    case ProcurementTenderType.GET_PROCUREMENT_LANE_INFORMATION_FAIL:
      return {
        ...state,
        LaneInformationList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.LaneInformationList,
          data: payload.data,
          error: true,
          progressing: false,
        },
      };

    case ProcurementTenderType.GET_PROCUREMENT_LANE_INFORMATION_REQUEST_RESET:
      return {
        ...state,
        LaneInformationList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.LaneInformationList,
          data: [],
        },
      };

    case ProcurementTenderType.GET_PROCUREMENT_ADD_LANE_INFORMATION:
      return {
        ...state,
        AddLaneInformationList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.AddLaneInformationList,
          progressing: true,
        },
      };

    case ProcurementTenderType.GET_PROCUREMENT_ADD_LANE_INFORMATION_SUCCESS:
      return {
        ...state,
        AddLaneInformationList: {
          ...state.AddLaneInformationList,
          data: payload.data.data,
          progressing: false,
          success: true,
        },
      };

    case ProcurementTenderType.GET_PROCUREMENT_ADD_LANE_INFORMATION_FAIL:
      return {
        ...state,
        AddLaneInformationList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.AddLaneInformationList,
          data: payload?.data,
          error: true,
          progressing: false,
          totalActive: 0,
          totalApproved: 0,
          totalCount: 0,
        },
      };

    case ProcurementTenderType.GET_TENDER_CARRIER_LIST:
      return {
        ...state,
        transportProviderList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.transportProviderList,

          progressing: true,
        },
      };

    case ProcurementTenderType.GET_TENDER_CARRIER_LIST_SUCCESS:
      return {
        ...state,
        transportProviderList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.transportProviderList,
          data: payload.data,
          progressing: false,
          success: true,
        },
      };

    case ProcurementTenderType.GET_TENDER_CARRIER_LIST_FAIL:
      return {
        ...state,
        transportProviderList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.transportProviderList,
          data: payload.data,
          error: true,
          progressing: false,
        },
      };

    case ProcurementTenderType.GET_TENDER_CARRIER_LIST_REQUEST_RESET:
      return {
        ...state,
        transportProviderList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.transportProviderList,
          data: [],
          req: {
            ...state.transportProviderList.req,
            payload,
          },
        },
      };

    case ProcurementTenderType.GET_PROCUREMENT_HISTORICAL_BID_LIST:
      return {
        ...state,
        historicalBidList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.historicalBidList,
          progressing: true,
          req: {
            ...state.historicalBidList.req,
            ...payload,
          },
        },
      };

    case ProcurementTenderType.GET_PROCUREMENT_HISTORICAL_BID_LIST_SUCCESS:
      return {
        ...state,
        historicalBidList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.historicalBidList,
          data: payload.data,
          progressing: false,
          success: true,
        },
      };

    case ProcurementTenderType.GET_PROCUREMENT_HISTORICAL_BID_LIST_FAIL:
      return {
        ...state,
        historicalBidList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.historicalBidList,
          data: payload.data,
          error: true,
          progressing: false,
        },
      };

    case ProcurementTenderType.GET_PROCUREMENT_HISTORICAL_BID_LIST_REQUEST_RESET:
      return {
        ...state,
        historicalBidList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.historicalBidList,
          data: {} as ProcurementTenderHistoricalBid,
          req: {
            // @ts-expect-error
            ...state?.historicalBidList?.Req,
            ...payload,
          },
        },
      };

    default:
      return state;
  }
};

// biome-ignore lint/style/noDefaultExport: TODO: fix
export default ProcurementTenderReducer;
